import axios from 'axios'
import apiConfig from '@/config'

export default {
  getConfig(url) {
    axios
      .post(apiConfig.wechatJsUrl, {
        url: url,
      })
      .then(function (res) {
        let getMsg = res.data.data
        wx.config({
          debug: false, //生产环境需要关闭debug模式
          appId: getMsg.appId, //appId通过微信服务号后台查看
          timestamp: getMsg.timestamp, //生成签名的时间戳
          nonceStr: getMsg.nonceStr, //生成签名的随机字符串
          signature: getMsg.signature, //签名
          jsApiList: [
            //需要调用的JS接口列表
            'updateAppMessageShareData',
            'updateTimelineShareData',
          ],
        })
      })
  },
  wxShowMenu(url, shareInfo) {
    wx.ready(function () {
      // wx.checkJsApi({
      //   jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
      //   success: function (res) { },
      //   errow: function (r) { },
      // })
      //分享到朋友圈
      wx.updateTimelineShareData({
        title: shareInfo.desc, // 分享标题
        link: url, // 分享链接
        imgUrl: shareInfo.imgUrl, // 分享图标
        success: function () {
          // _jcq.push(['_track', 'H5_Share', {
          //   Campaign: shareInfo.title
          // }])
        },
      })
      //分享给朋友
      wx.updateAppMessageShareData({
        title: shareInfo.title, // 分享标题
        desc: shareInfo.desc, //分享描述
        link: url, // 分享链接
        imgUrl: shareInfo.imgUrl, // 分享图标
        success: function () {
          // _jcq.push(['_track', 'H5_Share', {
          //   Campaign: shareInfo.title
          // }])
        },
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/wx.jsapi.js